export enum ChangePasswordFormField {
  CurrentPassword = 'oldPassword',
  NewPassword = 'password',
  RepeatPassword = 'repeatPassword',
}
